var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.19%",
    y1: "14.385%",
    x2: "80.155%",
    y2: "84.855%",
    id: "7z1g43cfda"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.168%",
    y1: "32.584%",
    x2: "84.388%",
    y2: "67.192%",
    id: "2jzh5pqj6b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.842 8H2.158C4.926 3.222 10.082 0 16 0s11.074 3.222 13.842 8zM16 32c5.918 0 11.074-3.222 13.842-8H2.158c2.768 4.778 7.924 8 13.842 8z",
    fill: "url(#7z1g43cfda)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-2.918-.794-5.645-2.158-8H2.158a15.908 15.908 0 0 0 0 16h27.684A15.908 15.908 0 0 0 32 16z",
    fill: "url(#2jzh5pqj6b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.aef23884617312843ddd913a87a31ab2.svg";
export { ForwardRef as ReactComponent };